import { FunctionCallAction, Transaction } from '@near-wallet-selector/core';
import JSBI from 'jsbi';
import { DEFAULT_GAS, MEMO } from '../constants';

interface TransferTokensParams {
  tokenId: string;
  accountFrom: string;
  accountTo: string;
  amount: JSBI;
}

const transferToken = ({
  tokenId,
  accountFrom,
  accountTo,
  amount,
}: TransferTokensParams): Transaction => {
  const action: FunctionCallAction = {
    type: 'FunctionCall',
    params: {
      methodName: 'ft_transfer',
      args: {
        receiver_id: accountTo,
        amount: amount.toString(),
        memo: MEMO,
      },
      gas: DEFAULT_GAS,
      deposit: '1',
    },
  };

  const tx = {
    receiverId: tokenId,
    signerId: accountFrom,
    actions: [action],
  };

  return tx;
};

export { transferToken };
